/**
 * @desc 财务画像-财务造假分析-造假异常点汇总
 * @author caoyx
 */
import styles from '../common.scss';
import React, { PureComponent } from 'react';
import { Table } from 'antd';
import { PAGE_SIZE } from '../../../../constants/common';
import GroupBox from '../../../common/groupBox/GroupBox';
import { linkageAnalysis } from './columns';
import { getCombineIndexColumns } from '../../common/commons';

export default class AbnormalSummary extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            //
        };
    }

    createKey = (d) => {
        return d.abnormalType + d.abnormalValue;
    };
    
    render() {
        const { data, analysisData = [], loading } = this.props;
        const { financeAbnormalAnalysisSummaryDtoList = [] } = data;
        return (
            <GroupBox title="舞弊异常点汇总">
                <div>
                    <div className="sub-title">异常指标</div>
                    <Table
                        bordered
                        className="table-margin"
                        loading={loading}
                        rowKey={this.createKey}
                        dataSource={financeAbnormalAnalysisSummaryDtoList}
                        columns={getCombineIndexColumns(financeAbnormalAnalysisSummaryDtoList)}
                        pagination={false}
                    />
                </div>

                <div className={styles.linkageAnalysis}>
                    <div className="sub-title">舞弊路径</div>
                    <Table
                        bordered
                        loading={loading}
                        rowKey="key"
                        dataSource={analysisData}
                        columns={linkageAnalysis}
                        pagination={analysisData.length > PAGE_SIZE}
                    />
                </div>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/AbnormalSummary.jsx